import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { Subscription } from 'rxjs';
import { mapObject } from '../../../helpers/mapObject';

@Component({
  selector: 'gtd-group-checkbox',
  templateUrl: './group-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GroupCheckboxComponent),
      multi: true,
    },
  ],
})
@DestroySubscribers()
export class GroupCheckboxComponent implements OnInit, ControlValueAccessor {
  @Input() data: Record<string, string>;
  @Input() label: string;
  public selectAllControl = new FormControl(false);
  public formGroup = new FormGroup({});
  public onTouched: () => void = () => {};
  public hideSelectAll = false;

  private subscribers: Record<string, Subscription> = {};
  private checkboxes: Record<string, boolean> = {};
  private onChange: (_: any) => void = () => {};

  constructor(private fb: FormBuilder) {}

  public ngOnInit() {
    this.checkboxes = mapObject(this.data, () => false);
    this.hideSelectAll = Object.keys(this.checkboxes).length <= 1;
    this.formGroup = this.fb.group(mapObject(this.checkboxes, () => new FormControl(false)));
    this.subscribers.selectAllControlChanges = this.selectAllControl.valueChanges.subscribe((selectAll) => {
      this.formGroup.setValue(mapObject(this.checkboxes, () => selectAll));
    });
    this.subscribers.formGroupChanges = this.formGroup.valueChanges.subscribe((value) => {
      this.onChange(Object.keys(value).filter((key) => value[key]));
      this.selectAllControl.patchValue(
        Object.keys(value).every((key) => value[key]),
        { emitEvent: false }
      );
    });
  }

  public writeValue(value: string[]): void {
    if (value) {
      this.checkboxes = value.reduce((checkboxes, key) => ({ ...checkboxes, [key]: true }), this.checkboxes);
      this.formGroup.patchValue(this.checkboxes, { emitEvent: false });
      this.selectAllControl.patchValue(value.length === Object.keys(this.checkboxes).length, { emitEvent: false });
    }
  }

  public registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.disable({ emitEvent: false });
      this.selectAllControl.disable({ emitEvent: false });
    } else {
      this.formGroup.enable({ emitEvent: false });
      this.selectAllControl.enable({ emitEvent: false });
    }
  }
}
